import { Component, ReactNode } from "react";

type Props = { children: ReactNode; fallback?: ReactNode };
type State = { hasError: boolean };

/**
 * Generic error boundary. Alchely handles medical data — a crash in one
 * feature module must not take down the whole application.
 */
export class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback ?? <p>Something went wrong.</p>;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
